import Vue from 'vue';
import { Component, Inject, Watch, Prop } from 'vue-property-decorator';
import OneButtonModal from '../../components/oneButtonModal';
import util from '../../shared/util';
import template from './sidebar.vue';

const DEFAULT_NAVIGATIONS = [
  {
    title: 'Dashboard',
    to: '/home',
    icon: require('@/assets/images/navbar/dashboard.svg'),
  },
  {
    title: 'Track Shipment',
    to: '/trackShipmentLoggedIn',
    icon: require('@/assets/images/navbar/shipment.svg'),
  },
  {
    title: 'Ship',
    to: '',
    icon: require('@/assets/images/navbar/ship.svg'),
    child: [
      {
        title: 'Quotes',
        to: '/quoteList',
      },
      {
        title: 'Shipments',
        to: '/shipment',
      },
      {
        title: 'Resources',
        to: '/resources',
      },
    ],
  },
  {
    title: 'Claims and Disputes',
    to: '/claimsAndDisputes',
    icon: require('@/assets/images/navbar/doller.svg'),
  },
  {
    title: 'Tasks',
    to: '/tasks',
    icon: require('@/assets/images/navbar/tasks.svg'),
  },
  {
    title: 'Your Business',
    icon: require('@/assets/images/navbar/business.svg'),
    child: [
      {
        title: 'Products',
        to: '/savedProducts',
      },
      {
        title: 'Address Book',
        to: '/newAddressBook',
      },
      {
        title: 'Invoices',
        to: '/invoices',
      },
    ],
  },
  {
    title: 'Settings',
    to: '',
    icon: require('@/assets/images/navbar/settings.svg'),
    child: [
      {
        title: 'Company Account',
        to: '/companyAccount',
      },
      {
        title: 'User profile',
        to: '/userProfile',
      },
    ],
  },
];

@Component({
  mixins: [template],
  components: {
    OneButtonModal,
  },
})
export default class Sidebar extends Vue {
  @Inject('reload') readonly reload!: Function;
  @Prop({ type: Boolean, default: false }) readonly isClaimsAccess!: boolean;
  @Prop({ type: Boolean, default: false }) readonly isSBCust!: boolean;

  isFold: boolean = false;
  isLevelSmall: boolean = false;
  isFoldDetails: boolean = false;
  navName: string = 'Dashboard';
  details = {};
  detailActive = '';
  isGuideDone: boolean = false;
  guideDoneName: string = 'Dashboard';
  guideDones: any = '';

  navLink: any = [];
  
  get claimsAccessFromStorage(): boolean {
    return localStorage.getItem('isClaimsAccess') === 'true' || 
           localStorage.getItem('ClaimsAccess') === '1';
  }
  
  get sbCustFromStorage(): boolean {
    // 直接从 localStorage 获取值，该值在 fetchUserRoles 中已经被设置
    return localStorage.getItem('isSBCust') === 'true';
  }

  get hasClaimsRestriction() {
    const claimsAccess = this.isClaimsAccess || this.claimsAccessFromStorage;
    const sbCust = this.isSBCust || this.sbCustFromStorage;
    return claimsAccess && sbCust;
  }

  get filteredNavLink() {
    if (this.hasClaimsRestriction) {
      return this.navLink.filter((item: any) => item.to === '/claimsAndDisputes');
    }
    return this.navLink;
  }

  routerNav(routerNamre: any, isGotoRouter: boolean = true) {
    switch (routerNamre) {
      case 'Home':
        this.foldDetails(true, this.navLink[0], isGotoRouter);
        this.navName = this.navLink[0].title;
        break;
      case 'Quote':
        this.foldDetails(true, this.navLink[2], isGotoRouter);
        this.isFold = false;
        this.isFoldDetails = true;
        this.detailActive = 'Quotes';
        break;
      case 'trackShipmentLoggedIn':
        this.foldDetails(true, this.navLink[1], isGotoRouter);
        this.navName = this.navLink[1].title;
        break;
      case 'TrackingGuest':
        this.foldDetails(true, this.navLink[1], false);
        this.navName = this.navLink[1].title;
        break;
      case 'claimsAndDisputes':
        this.foldDetails(true, this.navLink[3], isGotoRouter);
        this.navName = this.navLink[3].title;
        break;
      case 'Tasks':
        this.foldDetails(true, this.navLink[4], isGotoRouter);
        this.navName = this.navLink[4].title;
        break;
      case 'SavedProducts':
        this.foldDetails(true, this.navLink[5], isGotoRouter);
        this.isFold = false;
        this.isFoldDetails = true;
        this.navName = this.navLink[5].title;
        this.detailActive = 'Products';
        break;
      case 'newAddressBook':
        this.foldDetails(true, this.navLink[5], isGotoRouter);
        this.isFold = false;
        this.isFoldDetails = true;
        this.navName = this.navLink[5].title;
        this.detailActive = 'Address Book';
        break;
      case 'Invoices':
        this.foldDetails(true, this.navLink[5], isGotoRouter);
        this.isFold = false;
        this.isFoldDetails = true;
        this.navName = this.navLink[5].title;
        this.detailActive = 'Invoices';
        break;
      case 'ViewShipment':
        this.foldDetails(true, this.navLink[5], isGotoRouter);
        this.isFold = false;
        this.isFoldDetails = true;
        this.navName = this.navLink[5].title;
        this.detailActive = 'Invoices';
        break;
      case 'CompanyAccount':
        this.foldDetails(true, this.navLink[6], isGotoRouter);
        this.isFold = false;
        this.isFoldDetails = true;
        this.navName = this.navLink[6].title;
        break;
      case 'UserProfile':
        this.foldDetails(true, this.navLink[6], isGotoRouter);
        this.isFold = false;
        this.isFoldDetails = true;
        this.navName = this.navLink[6].title;
        break;
      case 'shipment':
        this.foldDetails(true, this.navLink[2], isGotoRouter);
        this.isFold = false;
        this.isFoldDetails = true;
        this.navName = this.navLink[2].title;
        this.detailActive = 'Shipments';
        break;
      case 'ShipmentView':
        if (localStorage.getItem('ShipmentViewFrom') == '1') {
          this.foldDetails(true, this.navLink[5]);
          this.isFold = false;
          this.isFoldDetails = true;
          this.navName = this.navLink[5].title;
          this.detailActive = 'Invoices';
        } else if (localStorage.getItem('ShipmentViewFrom') == '3') {
          this.foldDetails(true, this.navLink[4], isGotoRouter);
          this.navName = this.navLink[4].title;
        } else if (localStorage.getItem('ShipmentViewFrom') == '4') {
          this.foldDetails(true, this.navLink[2]);
          this.isFold = false;
          this.isFoldDetails = true;
          this.detailActive = 'Quotes';
        } else {
          this.foldDetails(true, this.navLink[2], isGotoRouter);
          this.isFold = false;
          this.isFoldDetails = true;
          this.navName = this.navLink[2].title;
          this.detailActive = 'Shipments';
        }
        break;
      case 'QuoteList':
        this.foldDetails(true, this.navLink[2], isGotoRouter);
        this.isFold = false;
        this.isFoldDetails = true;
        this.navName = this.navLink[2].title;
        this.detailActive = 'Quotes';
        break;
      case 'Resources':
        this.foldDetails(true, this.navLink[2], isGotoRouter);
        this.isFold = false;
        this.isFoldDetails = true;
        this.navName = this.navLink[2].title;
        this.detailActive = 'DocumentsAndForms';
        break;
      case 'estimatedQuote':
        this.foldDetails(true, this.navLink[2], isGotoRouter);
        this.isFold = false;
        this.isFoldDetails = true;
        this.navName = this.navLink[2].title;
        this.detailActive = 'Quotes';
        break;
      case 'ScheduleApickup':
        this.foldDetails(true, this.navLink[2], isGotoRouter);
        this.isFold = false;
        this.isFoldDetails = true;
        this.navName = this.navLink[2].title;
        this.detailActive = 'Quotes';
        break;
      case 'ScheduleApickup':
        this.foldDetails(true, this.navLink[2], isGotoRouter);
        this.isFold = false;
        this.isFoldDetails = true;
        this.navName = this.navLink[2].title;
        break;
      default:
    }
  }

  mounted() {
    this.navLink = DEFAULT_NAVIGATIONS;

    const routerNamre = this.$route.name;
    this.routerNav(routerNamre);

    const script = document.createElement('script');
    script.type = 'text/javascript';
    script.setAttribute('class', 'getting-started-up-js');
    script.appendChild(
      document.createTextNode(
        ` function hideGettingbox() {  var node = document.querySelector(".getting-started-box"); if (node && node.parentNode) { node.style.display = "none"; } };function showGettingbox() {  var node = document.querySelector(".getting-started-box"); if (node && node.parentNode) { node.style.display = "block"; } };`,
      ),
    );
    document.body.appendChild(script);
  }

  @Watch('isFold')
  watchIsFold(to: any, from: any) {
    this.$emit('onSidebar', !this.isFold);
  }

  @Watch('$route')
  routechange(to: any, from: any) {
    this.routerNav(to.name, false);
  }

  created() {
    this.guideDones = util.guideDoneData();
    let _this = this;
    (window as any).gotItGettingd = _this.gotItGettings;
    this.isGuideDone = localStorage.getItem('guideDone') == 'true' ? true : false;
  }

  togoaside(isfold: boolean) {
    if (this.isFoldDetails) this.isLevelSmall = true;
    this.isFold = !isfold;
  }

  foldDetails(isFoldDetails: boolean, item: any, foldDetails: boolean = true) {
    this.navName = item.title;
    this.details = { title: item.title, child: item.child };
    if (item.child) {
      if (!isFoldDetails) this.isFoldDetails = true;
      this.isFold = false;
      this.isLevelSmall = true;
    } else {
      this.isLevelSmall = false;
      this.isFoldDetails = false;
      if (foldDetails) {
        this.$router.push(item.to);
      }
    }
    this.detailActive = '';
    if (this.$route.name == 'trackShipmentLoggedIn') {
      this.reload();
    }
  }

  onDetail(detail: any) {
    this.detailActive = detail.title;
  }

  onClickLogo() {
    this.$router.push({
      name: 'Home',
    });
  }

  gotItGettings(name: any, isNew: boolean = false) {
    if (name == 'finished') {
      let stageNumber = localStorage.getItem('guideDoneStageNumber');
      if (stageNumber) {
        localStorage.setItem('guideDoneStageNumber', String(Number(stageNumber) + 1));
      } else localStorage.setItem('guideDoneStageNumber', '1');
      localStorage.setItem('guideDoneStage', name);
      return;
    }
    if (isNew && name == 'Quotes') {
      this.$router.replace({
        name: 'Quote',
      });
      this.foldDetails(true, this.navLink[2]);
      this.isFold = false;
      this.isFoldDetails = true;
    }
    if (isNew && name == 'QuotesListItem') {
      this.$router.replace({
        name: 'QuoteList',
      });
    }
    if (isNew && name == 'ShipmentListItem') {
      this.$router.push({
        name: 'shipment',
      });
    }
    if (isNew && name == 'Shipments') {
      let gettingStartedId = localStorage.getItem('gettingStartedId');
      if (gettingStartedId) {
        this.$router.push({
          name: 'estimatedQuote',
          query: {
            quoteId: gettingStartedId,
          },
        });
        this.foldDetails(true, this.navLink[2]);
        this.isFold = false;
        this.isFoldDetails = true;
      } else
        this.$router.push({
          name: 'shipment',
        });
    }
    setTimeout(() => {
      this.gettingStarted({
        class: `getting-started-with getting-${name}`,
        id: name,
        html: this.guideDones[name],
      });
    }, 100);
    localStorage.setItem('guideDoneStage', name);
  }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--1!./src/components/sidebar/index.ts